import React, { Component } from "react";
import axios from "axios";
import { InputText } from "primereact/inputtext";
import { Messages } from "primereact/messages";
import { Growl } from "primereact/growl";
import * as appConst from "../../Common/constants";

export default class Add extends Component {
  constructor(props) {
    super(props);

    this.state = {
      name: this.props.pData.name,
      damage: this.props.pData.stock.damage,
      qty: 0,
      desc: ""
    };
  }

  render() {
    return (
      <div>
        <div>
          <h5 align="center">Dispose Equipment</h5>
        </div>
        <div>
          <div className="container-fluid">
            <div className="row p-1 border">
              <div className="col col-md-2">Name</div>
              <div className="col col-md-3">{this.state.name}</div>
            </div>
            <div className="row p-1 border">
              <div className="col col-md-2">Damaged</div>
              <div className="col col-md-3">{this.state.damage}</div>
            </div>
            <div className="row p-1 border">
              <div className="col col-md-2">Quantity</div>
              <div className="col col-md-3">
                <InputText
                  type="text"
                  keyfilter="pint"
                  value={this.state.qty}
                  onChange={e => this.setState({ qty: e.target.value })}
                  style={{ width: "300px" }}
                />
              </div>
            </div>
            <div className="row p-1 border">
              <div className="col col-md-2">Description</div>
              <div className="col col-md-3">
                <InputText
                  type="text"
                  value={this.state.desc}
                  onChange={e => this.setState({ desc: e.target.value })}
                  style={{ width: "300px" }}
                />
              </div>
            </div>
            <div className="row p-1 border">
              <button
                onClick={this.onSaveClick}
                className="btn btn-primary btn-md mr-2"
              >
                Save
              </button>
              <button
                onClick={this.onClearClick}
                className="btn btn-primary btn-md mr-2"
              >
                Clear
              </button>
              <button
                onClick={this.onCancelClick}
                className={this.getCancelClass()}
              >
                Cancel
              </button>
            </div>
            <Growl ref={el => (this.growl = el)} />
            <Messages ref={el => (this.messages = el)} />
          </div>
        </div>
      </div>
    );
  }

  getCancelClass() {
    let clsName = "btn btn-primary btn-md mr-2 ";
    if (this.props.source === "list") {
      clsName += "visible";
    } else {
      clsName += "invisible";
    }
    return clsName;
  }

  onSaveClick = e => {
    e.preventDefault();
    if (this.state.qty === 0 || this.state.qty > this.state.damage) {
      this.messages.show({
        severity: "error",
        summary: "Error !!",
        detail: "Invalid Quantity !!"
      });
    } else {
      const obj = {
        eno: this.props.pData.eno,
        name: this.props.pData.name,
        qty: this.state.qty,
        desc: this.state.desc,
        eid: this.props.pData._id
      };

      axios
        .post(
          (process.env.NODE_ENV !== "development"
            ? appConst.API_URL_PROD
            : appConst.API_URL_DEV) +
            
            "/equipment/dispose",
          obj
        )
        .then(res => {
          this.props.onClick("Print", res.data);
        });
    }
  };

  ClearData() {
    this.setState({
      qty: 0,
      desc: ""
    });
  }

  onClearClick = e => {
    this.ClearData();
    this.growl.show({
      severity: "success",
      summary: "Success",
      detail: "Data Cleared !!!"
    });
  };

  onCancelClick = e => {
    this.props.onClick("List", null);
  };
}
